<template>
    <div class="personConRate">
        <v-header title="个人继续率"></v-header>
        <div class="conH"></div>
        <div class="header">
            <label>{{username}}个人继续率</label>
            <div class="right">
                <span>时间</span>
                <el-date-picker
                    type="month"
                    :editable="false"
                    size="mini"
                    value-format="yyyy-MM"
                    v-model="startMonth"
                    :clearable='false'
                    :picker-options='pickerOptions'
                    >
                </el-date-picker>
                <span>到</span>
                <el-date-picker
                    type="month"
                    :editable="false"
                    size="mini"
                    value-format="yyyy-MM"
                    v-model="endMonth"
                    :clearable='false'
                    :picker-options='pickerOptions'
                    >
                </el-date-picker>
                <el-button size="mini" type="primary" @click="init()">查询</el-button>
            </div>
        </div>
        <div class="main">
            <div class="option">
                <ul>
                    <li id="init13" class="border-init init" @click="chooseType('13', $event)"><span>13个月</span></li>
                    <li class="init" @click="chooseType('25', $event)"><span>25个月</span></li>
                    <li class="init" @click="chooseType('37', $event)"><span>37个月及以上</span></li>
                </ul>
            </div>
            <div class="content">
                <div class="moneyTotal">
                    <div class="title" @click="arrow('money','money-content')">
                        <label>保费统计</label> <img id="money" class="arrow" src="../../../static/image/arrow.png" />
                    </div>
                    <div class="money-content" id="money-content">
                        <table>
                            <thead>
                                <td>在职单应收保费</td>
                                <td>在职单实收保费</td>
                                <td>孤儿单应收保费</td>
                                <td>孤儿单实收保费</td>
                                <td>合计应收保费</td>
                                <td>合计实收保费</td>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{result.instPremN}}</td>
                                    <td>{{result.realtPremN}}</td>
                                    <td>{{result.instPremI}}</td>
                                    <td>{{result.realPremI}}</td>
                                    <td>{{result.instPrem}}</td>
                                    <td>{{result.realPrem}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="moneyTotal">
                    <div class="title" @click="arrow('rate','rate-content')">
                        <label>继续率统计</label> <img id="rate" class="arrow" src="../../../static/image/arrow.png" />
                    </div>
                    <div id="rate-content" class="money-content">
                        <table>
                            <thead>
                                <td>在职单继续率</td>
                                <td>孤儿单继续率</td>
                                <td>合计继续率</td>
                                <td>继续率明细</td>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{result.realtPremNRate}}</td>
                                    <td>{{result.realPremIRate}}</td>
                                    <td>{{result.realPremRate}}</td>
                                    <td class="look">
                                        <span  @click="toDetail">查看</span>
                                        <span @click="exportExcel()">导出</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <el-dialog  :visible.sync="dialogTableVisible" width="90%" :modal-append-to-body="false" :center="true">
                    <el-table v-loading="loadingTable" :data="details" style="width: 100%" height="500" :header-cell-style="theadColor">

                        <el-table-column align="center" fixed width="100" property="chdrNum" label="投保单号"></el-table-column>
                        <el-table-column align="center" property="appFullName" label="投保人"></el-table-column>
                        <el-table-column align="center" width="200" property="cntName" label="产品名称"></el-table-column>
                        <el-table-column align="center" property="instPrem" label="应收保费"></el-table-column>
                        <el-table-column align="center" property="realPrem" label="实收保费"></el-table-column>
                        <el-table-column align="center" property="ptDate" label="到期日期"></el-table-column>
                        <el-table-column align="center" width="120" property="appCltPhoneOne" label="投保人联系方式1"></el-table-column>
                        <el-table-column align="center" width="120" property="appCltPhoneTwo" label="投保人联系方式2"></el-table-column>
                        <el-table-column align="center" property="payTimes" label="交次"></el-table-column>
                        <el-table-column align="center" property="statName" label="保单状态"></el-table-column>
                        <el-table-column align="center" property="bankKey" label="扣款银行"></el-table-column>
                        <el-table-column align="center" width="200" property="bankAccKey" label="银保账号"></el-table-column>

                    </el-table>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import vHeader from '@/layout/Header1.vue'
export default {
  components: {vHeader},
  data () {
    return {
      loadingTable: false,
      pickerOptions: {
        disabledDate (time) {
          let _now = Date.now(),
            seven = 60 * 24 * 60 * 60 * 1000,
            sevenDays = _now + seven
          return time.getTime() > sevenDays
        }
      },
      username: '',
      startMonth: '',
      endMonth: '',
      req: {
        agentNum: '62001554',
        billcdStartDate: '',
        billcdEndDate: '',
        conRateType: '13'
      },
      detailReq: {},
      result: '',
      details: '',
      dialogTableVisible: false,
      theadColor: {
        color: '#C6A970',
        fontSize: '13px'
      }
    }
  },
  watch: {

  },
  methods: {
    compareDate () {
      console.log(new Date(this.endMonth))
      console.log(new Date(this.startMonth))
      if ((new Date(this.endMonth) - new Date(this.startMonth)) < 0) {
        alert('结束时间不能大于开始时间')
        return false
      } else {
        let diff = (new Date(this.endMonth) - new Date(this.startMonth)) / (1000 * 60 * 60 * 24 * 30)
        if (diff > 12) {
          alert('查询跨度应小于等于12个月')
          return false
        }
        return true
      }
    },
    dateChange () { // 日期改变时动态赋值
      this.req.billcdStartDate = this.startMonth
      this.req.billcdEndDate = this.endMonth
      this.compareDate()
    },
    chooseType (value, event) { // 动态赋值类型
      let els = document.getElementsByClassName('init')
      //let target = event.target
      let target = event.currentTarget
      target.classList.add('border-init')
      for (let i = 0; i < els.length; i++) {
        if (target !== els[i]) {
          els[i].classList.remove('border-init')
        }
      }

      this.req.conRateType = value
      this.init()
    },
    arrow (id, cid) { // 动画
      let el = document.getElementById(id)
      let content = document.getElementById(cid)
      let classN = el.getAttribute('class')
      if (!classN.includes('arrow-go')) {
        el.classList.remove('arrow-back')
        el.classList.add('arrow-go')
        content.classList.add('open')
      } else {
        el.classList.remove('arrow-go')
        el.classList.add('arrow-back')
        content.classList.remove('open')
      }
    },
    init () {
      let that = this
      if(!this.compareDate()){
        return
      } 
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let startDate = new Date(this.startMonth);
      let endDate = new Date(this.endMonth);
      let start = startDate.getMonth() + 1;
      let end = endDate.getMonth() + 1;
      if(start < 10){
        start = "0" + start
      }
      if(end < 10){
        end = "0" + end;
      }
      this.req.billcdStartDate = startDate.getFullYear() + "-" + start;
      this.req.billcdEndDate = endDate.getFullYear() + "-" + end;
      api.post(url.getPersonalConRate, this.req, function (res) {
        loading.close();
        that.result = res.data.data
      })
      api.post(url.getPuserInfo, this.req, function (res) {
        that.username = res.data.psnName
      })
    },
    toDetail () { // 获取个人继续率保单详情
      this.loadingTable = true;
      this.dialogTableVisible = true
      this.detailReq = this.req
      this.detailReq.startIndex = '0'
      this.detailReq.limit = '100'
      let that = this
      api.post(url.getPersonalConRateDetail, this.detailReq, function (res) {
        console.log(res)
        that.loadingTable = false
        that.details = res.data.data.personConRateDetails
      })
    },
    format() {
      // 格式化时间
      let current = new Date()
      let year = current.getFullYear()
      let month = current.getMonth() + 1
      let month2 = current.getMonth() + 3
      let year2 = current.getFullYear()
      if(month2>12){
        month2=month2-12
        year2=year2+1
      }
      if (month < 10) {
        month = '0' + month
      }
      if (month2 < 10) {
        month2 = '0' + month2
      }
      let start = year + '-' + month
      this.req.billcdStartDate = start
      this.startMonth = new Date(start)
      let end = year2 + '-' + month2
      this.req.billcdEndDate = end
      this.endMonth = new Date(end)
    },
    exportExcel () { // 导出Excel文件
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.detailReq = this.req
      this.detailReq.startIndex = '0'
      this.detailReq.limit = '100'
      let that = this
      api.post(url.exportExcel, this.req, function (res) {
        // let blob = that.getBlob(res.data.loadUrl)
        // 用a标签下载blob文件
        const elink = document.createElement('a')
        elink.download = '个人继续率保单列表.xls'

        elink.style.display = 'none'
        elink.href = res.data.loadUrl // URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        loading.close();
        // URL.revokeObjectURL(blob)
        document.body.removeChild(elink)
      })
    },
    getBlob (value) { // 将base64转为blob对象
      let base64 = value.split(',')

      let bstr = atob(base64[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      let blob = new Blob([u8arr], {type: 'application/vnd.ms-excel;base64'})
      return blob
    }
  },
  mounted () {
    this.username = ''
    this.format()
    this.init()
  }
}
</script>

<style scoped>
.personConRate {
  background: #fff;
  /* padding-top: 1px; */
  width: 100%;
  height: 100%;
}
.header, .main{
    width: 90%;
    margin: 20px auto 10px auto;
}
.header{
    height: 30px;
}
.header label{
    color: #111111;
    font-size:18px;
    display: block;
    float: left;
}
.right{
    float: right;
    font-size: 10px;
}
.el-input__inner{
    width: 100px;
    height: 20px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 120px;
    opacity: 1;
    cursor: pointer;
}
.el-input--mini .el-input__inner{
    height: 20px;
}
.el-input--mini .el-input__icon {
    color: #194793;
    line-height: 20px;
}
.el-input__prefix{
    left: 0;
}
.main{
    padding-bottom: 30px;
    height: auto;
    margin-top: 2%;
}
.content{
    height: auto;
    font-size: 12px;
    color: #111111;
}
.option{
    height: 50px;
}
.option ul{
    list-style: none;
}
.option li{
    /* padding: 0 10px; */
    line-height: 30px;
    display: block;
    float: left;
    width: 33%;
    text-align: center;
    cursor: pointer;
    /* margin: 0 auto 0 15%; */
}
.border-init span{
    border-bottom: 3px solid #194793;
}
.option li span{padding: 4px 10px;}
.option li:hover span{
    border-bottom: 3px solid #194793;
}
.option li:focus span{
    border-bottom: 3px solid #194793;
}
.moneyTotal{
    min-height: 100px;
}
.moneyTotal:nth-child(2){
    margin-top: 30px;
}
.title{
    height: 31px;
    background: #F7F7F7;
    /* box-shadow: 0px 0px 0.5px 0.5px rgba(0,0,0,0.2); */
    border: 1px solid #E5E5E5;
    line-height: 31px;
    font-size: 13px;
    font-weight: 500;
    padding-left: 18px;
}
.arrow{
    width: 8px;
    height: 14px;
    float: right;
    position: relative;
    top:8px;
    right: 15px;
    transform:rotate(90deg);
}
.money-content{
    min-height: 69px;
    display: block;
    transition-duration: 1s;
    /* box-shadow: 0px 1px 0.5px 0.5px rgba(0,0,0,0.2); */
    border:1px solid #E5E5E5;
    margin-top: -1px;
}
table{
    width: 100%;
    text-align: center;
    border-top: none;
}
table td{
    width: 17%;
    height: 28px;
}
thead{
    color: #C6A970;
}
tbody span:nth-child(1){
    float: left;
}
tbody span:nth-child(2){
    float: right;
}
.look{
    color: #5B9FEC;
    padding: 0 6%;
}
.look span{
    cursor: pointer;
}
@keyframes arrow{
    0%{
        transform:rotate(0deg)
    }
    25%{
        transform:rotate(18deg)
    }
    50%{
        transform:rotate(36deg)
    }
    75%{
        transform:rotate(54deg)
    }
    100%{
        transform:rotate(90deg)
    }
 }
 @keyframes back{
    0%{
        transform:rotate(90deg)
    }
    25%{
        transform:rotate(54deg)
    }
    50%{
        transform:rotate(36deg)
    }
    75%{
        transform:rotate(18deg)
    }
    100%{
        transform:rotate(0deg)
    }
 }

.arrow-go{
    animation-name:back;
    transform:rotate(0deg);
    transition-timing-function:ease-in-out;
    animation-duration:0.1s;
}
.arrow-back{
    animation-name:arrow;
    transform:rotate(90deg);
    transition-timing-function:ease-in-out;
    animation-duration:0.1s;
}
.open{
  display: none;
}

.theadColor{
    color: #C6A970;
}
.personConRate >>> .el-dialog--center .el-dialog__body{ padding:10px 0 0 10px;}
.personConRate >>> .el-table__row td:nth-child(3){
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/personConRate.vue